module.exports = __webpack_public_path__ + "static/git-commits3-b96c16ff80c8028edcd25145f91b64ab.png";